// product.js
import { defineStore } from 'pinia'
import axios from 'axios'

export const useProductStore = defineStore('product', {
    state: () => ({
        allProduct: [],
        productList: [],

        allProductType: [],
        productTypeList: [],
        allProductClassifier: [],
        productClassifierList: [],

        shelterSelf: '',
        allTransferShelterList: [],
        allTransferProductList: [],
        transferProductLogs: [],

        shelterProductList: [],
        allShelterExceptionProductList: [],

        productRequestList: [],
        productRequestHistoryList: [],

        allProductGroup: [],

        allStockList: [],

        transferAllow: ''
    }),
    actions: {
        async getAllProduct(filter) {
            try {
                const response = await axios.get('/product', { params: filter })
                if (response.status === 200) {
                    this.allProduct = response.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getProduct(filter) {
            try {
                const response = await axios.get('/product', { params: filter })
                if (response.status === 200) {
                    this.productList = response.data.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async createProduct(body) {
            try {
                const response = await axios.post('/product', body)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async updateProduct(id, body) {
            try {
                const response = await axios.post(`/product/${id}`, body)
                if (response.status === 200) {
                    // console.log('response',response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async checkDeleteProduct(id, filter) {
            try {
                const response = await axios.get(`/product-check-del/${id}`, { params: filter })
                if (response.status === 200) {
                    //   console.log('response',response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async deleteProduct(id) {
            try {
                const response = await axios.delete(`/product/${id}`)
                if (response.status === 200) {
                    //   console.log('response',response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async updateProductQuantity(body) {
            try {
                const response = await axios.post(`/product-quantity/${body.id}`, body)
                if (response.status === 200) {
                    // console.log('response',response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        // product type
        async getAllProductType(filter) {
            try {
                const response = await axios.get('/category', { params: filter })
                if (response.status === 200) {
                    this.allProductType = response.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getProductType(filter) {
            try {
                const response = await axios.get('/category', { params: filter })
                if (response.status === 200) {
                    this.productTypeList = response.data.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async createProductType(body) {
            try {
                const response = await axios.post('/category', body)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async updateProductType(body) {
            try {
                const response = await axios.post(`/category/${body.id}`, body)
                if (response.status === 200) {
                    // console.log('response',response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async deleteProductType(id) {
            try {
                const response = await axios.delete(`/category/${id}`)
                if (response.status === 200) {
                    //   console.log('response',response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        // product classifier
        async getAllProductClassifier(filter) {
            try {
                const response = await axios.get('/unit', { params: filter })
                if (response.status === 200) {
                    this.allProductClassifier = response.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getProductClassifier(filter) {
            try {
                const response = await axios.get('/unit', { params: filter })
                if (response.status === 200) {
                    this.productClassifierList = response.data.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async createProductClassifier(body) {
            try {
                const response = await axios.post('/unit', body)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async updateProductClassifier(body) {
            try {
                const response = await axios.post(`/unit/${body.id}`, body)
                if (response.status === 200) {
                    // console.log('response',response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async deleteProductClassifier(id) {
            try {
                const response = await axios.delete(`/unit/${id}`)
                if (response.status === 200) {
                    //   console.log('response',response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        // transfer product
        async getProductShelterSelf(filter) {
            try {
                const response = await axios.get('/product-shelter-self', { params: filter })
                if (response.status === 200) {
                    this.shelterSelf = response.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getAllTransferShelterList(filter) {
            try {
                const response = await axios.get('/transfer-shelter-list', { params: filter })
                if (response.status === 200) {
                    this.allTransferShelterList = response.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getAllTransferProductList(filter) {
            try {
                const response = await axios.get('/transfer-product-list', { params: filter })
                if (response.status === 200) {
                    this.allTransferProductList = response.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getTransferProductLogs(filter) {
            try {
                const response = await axios.get('transfer-product-logs', { params: filter })
                if (response.status === 200) {
                    this.transferProductLogs = response.data.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async createTransferProduct(body) {
            try {
                const response = await axios.post('/transfer-product', body)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        // shelter
        async getShelterProduct(filter) {
            try {
                const response = await axios.get(`/shelter-product/${filter.shelter_id}`, { params: filter })
                if (response.status === 200) {
                    this.shelterProductList = response.data.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async createShelterProduct(body) {
            try {
                const response = await axios.post('/shelter-product', body)
                if (response.status === 200) {
                    // console.log('response:', response)
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async transferShelterAllProduct(filter) {
            try {
                const response = await axios.get('/shelter-all-transfer', { params: filter })
                if (response.status === 200) {
                    // console.log('response:', response)
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async DeleteShelterProduct(id, filter) {
            try {
                const response = await axios.get(`/shelter-one-delete/${id}`, { params: filter })
                if (response.status === 200) {
                    // console.log('response:', response)
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async DeleteShelterAllProduct(filter) {
            try {
                const response = await axios.get('/shelter-all-delete', { params: filter })
                if (response.status === 200) {
                    // console.log('response:', response)
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getAllShelterExceptionProduct(filter) {
            try {
                const response = await axios.get('/shelter-product-excep', { params: filter })
                if (response.status === 200) {
                    this.allShelterExceptionProductList = response.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        // request
        async getProductRequest(filter) {
            try {
                const response = await axios.get('/product-request', { params: filter })
                if (response.status === 200) {
                    this.productRequestList = response.data.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getProductRequestById(id) {
            try {
                const response = await axios.get(`/product-requests/${id}`)
                if (response.status === 200) {
                    // console.log('response:', response)
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async createProductRequest(body) {
            try {
                const response = await axios.post('/product-request', body)
                if (response.status === 200) {
                    // console.log('response:', response)
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async updateProductRequest(body) {
            try {
                const response = await axios.post(`/product-request/${body.id}`, body)
                if (response.status === 200) {
                    // console.log('response:', response)
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getProductRequestHistory(filter) {
            try {
                const response = await axios.get('/product-request-log', { params: filter })
                if (response.status === 200) {
                    console.log('response', response);

                    this.productRequestHistoryList = response.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },

        async getAllProductGroup(filter) {
            try {
                const response = await axios.get('/product-groups', { params: filter })
                if (response.status === 200) {
                    this.allProductGroup = response.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getStockList(filter) {
            try {
                const response = await axios.get('/stocks', { params: filter })
                if (response.status === 200) {
                    console.log('response', response.data.data.data);

                    this.allStockList = response.data.data.data
                    console.log(' this.allStockList', this.allStockList);

                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async exportStockList(filter) {
            try {
                const response = await axios.get('/export-stock', { params: filter })
                if (response.status === 200) {
                    console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },

        async getTransferAllow(filter) {
            try {
                const response = await axios.get('/transfer-allow', { params: filter })
                if (response.status === 200) {
                    this.transferAllow = response.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
    }
})
